export default __webpack_public_path__ + "/dist/images/4075291.png";